// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

export const useHolderServiceRequests = <T = TemplateContract<HolderServiceRequest>[]>(
  select?: (data: TemplateContract<HolderServiceRequest>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();

  return useQueryWithOffset({
    enabled: !!operator,
    queryKey: ['queryRegistryHolderServiceRequests', party, operator],
    queryFn: async (_, offset) => {
      return ledgerApi.queryRegistryHolderServiceRequests(offset, operator);
    },
    select,
  });
};
